module.exports = __webpack_public_path__ + "img/avatar0.9da798fc.png";